<div
  class="rounded-lg border border-outline dark:border-outline-darkmode h-full w-full flex flex-col overflow-hidden"
>
  <div class="py-5 px-6 flex-none flex gap-2 items-center">
    <ui-skeleton class="flex-none size-10.5 rounded-lg inline-block" />
    <div class="flex-1 flex flex-col gap-1">
      <ui-skeleton class="block max-w-full w-[200px] h-3 rounded-full" />
      <ui-skeleton class="block max-w-full w-[100px] h-3 rounded-full" />
    </div>
  </div>
  <div class="flex-1 p-6 border-t border-outline dark:border-outline-darkmode">
    <div class="flex flex-col gap-4 text-sm">
      <!-- locations -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[70px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <!-- energyInterfaces -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[85px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <!-- start -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[100px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <!-- end -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[100px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <hr class="border-outline dark:border-outline-darkmode" />
      <!-- consumption -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[200px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <!-- price -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[150px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
      <!-- cost -->
      <div class="flex gap-1">
        <div class="font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
          <ui-skeleton class="inline-block w-[160px] h-3 rounded-full" />
        </div>
        <ui-skeleton class="inline-block w-18 h-6 rounded-lg" />
      </div>
    </div>
  </div>
  <div class="pt-5 pb-4 px-6 flex-none">
    <ui-skeleton class="inline-block w-full h-10 rounded-md" />
  </div>
</div>
